import { TaskDefinition, useTasksBoardAll } from '@/feature/execution-board'

import { useAreTasksEnabled } from './useObservatoryTasks'

/**
 * Resolves the currently focused task.
 *
 * The map's task layer is status-filtered (see useObservatoryTasks), so the focused task — which
 * can be opened from the Execution Board for any status — may not be in that set. In that case
 * (and only then) fetch the full task set to resolve it. This keeps focus working for any task
 * WITHOUT changing which tasks the layer renders, so focusing/unfocusing never makes the layer's
 * markers or counts change.
 */
export const useFocusedTask = (
  focusedTaskId: string | undefined,
  layerTasks: TaskDefinition[] | undefined,
): TaskDefinition | undefined => {
  const isEnabled = useAreTasksEnabled()

  const fromLayer =
    isEnabled && focusedTaskId
      ? layerTasks?.find((task) => task.id === focusedTaskId)
      : undefined

  const needsFullFetch = isEnabled && !!focusedTaskId && !fromLayer
  const { data: allTasks } = useTasksBoardAll(
    needsFullFetch ? { pageSize: Number.MAX_SAFE_INTEGER } : null,
  )

  if (!isEnabled || !focusedTaskId) {
    return undefined
  }

  return fromLayer ?? allTasks?.results?.find((task) => task.id === focusedTaskId)
}
